import { FETCH_APP_DATA_ASYNC } from 'containers/App/constants'
import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import {
  FORCE_REFETCH_FFS,
  INTELLIGENCE_SETTINGS_REQUEST_ASYNC,
  TOGGLE_SPAM_FF_REQUEST_ASYNC,
  UPDATE_INTELLIGENCE_SETTINGS_REQUEST_ASYNC,
} from './constants'

export default function () {
  const initialState = {
    loader: false,
    data: {},
    error: null,
    federationError: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case COMPANY_FILTER_CHANGE:
      case INTELLIGENCE_SETTINGS_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true, federationError: null }
      case INTELLIGENCE_SETTINGS_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          loader: false,
          data: action.payload.data,
        }

      case FORCE_REFETCH_FFS:
      case TOGGLE_SPAM_FF_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          loader: true,
        }
      case FETCH_APP_DATA_ASYNC.SUCCESS:
        return {
          ...state,
          loader: false,
        }
      case INTELLIGENCE_SETTINGS_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case INTELLIGENCE_SETTINGS_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case UPDATE_INTELLIGENCE_SETTINGS_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true, federationError: null }
      case UPDATE_INTELLIGENCE_SETTINGS_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          federationError: action.error.detail.response,
          loader: false,
        }
      default:
        return state
    }
  }
}
